<template lang="html" src="./ManageCompany.html">

</template>
<script>
import listContract from "../Contract/Contract.vue";
import company from "../Company/Company/Company.vue";
import poolAccountProfile from "../PoolAccount/Profile/Profile.vue";
import poolAccountCompany from "../PoolAccount/Company/Company.vue";
import poolAccountExtrato from "../PoolAccount/Extrato/Extrato.vue";
import poolAccountPlans from "../Plans/Plan.vue";
import employee from "../Employees/Employee/Employee.vue";
import employeesWithPendingFees from "../Employees/EmployeesWithPendingFees/EmployeesWithPendingFees.vue";
import employeesAndCreditRecharge from "../Employees/EmployeesAndCreditRecharge/EmployeesAndCreditRecharge.vue";
import employeePaymentReport from "../Employees/EmployeePaymentReport/EmployeePaymentReport.vue";
import employeeSpreadSheet from "../Employees/EmployeeSpreadSheet/EmployeeSpreadSheet.vue";
import companyCampaigns from "../CompanyCampaigns/CompanyCampaigns.vue";
import plans from "../Plans/Plan.vue";
export default {
  components: {
    "list-contract": listContract,
    "pool-account-profile": poolAccountProfile,
    "pool-account-company": poolAccountCompany,
    "pool-account-extrato":poolAccountExtrato,
    "pool-account-plans": poolAccountPlans,
    "employees-with-pending-fees": employeesWithPendingFees,
    "employees-and-credit-recharge": employeesAndCreditRecharge,
    "employee-payment-report": employeePaymentReport,
    'campaigns': companyCampaigns,
    "employee-spread-sheet" : employeeSpreadSheet,
    company,
    employee,
    plans
  },
  data() {
    return {
      companyName: "",
      dashboardCompanyShow: false,
      contractsShow: false,
      campaignsShow: false,
      companyShow: false,
      poolAccountProfileShow: false,
      poolAccountCompanyShow: false,
      poolAccountExtratoShow: false,
      poolAccountPlansShow: false,
      employeeShow: false,
      employeesWithPendingFeesShow: false,
      employeesAndCreditRechargeShow: false,
      employeePaymentReportShow: false,
      plansShow: false,
      employeeSpreadSheetShow: false,
      bearerDefault: ""
    };
  },
  mounted() {
    const vm = this;
    vm.bearerDefault = vm.$session.get("bearerDefault");
    vm.$session.set("bearerDefault", vm.bearerDefault);
    if (vm.$route.params) {
      vm.companyName = vm.$route.params.name.toUpperCase();
      vm.init();
    }
  },
  methods: {
    init() {
      const vm = this;
      vm.getCompany();
      vm.companyShow = true;
    },
    showPlans(){
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = false;
      vm.campaignsShow = false;
      vm.companyShow = false;
      vm.poolAccountProfileShow = false;
      vm.poolAccountCompanyShow = false;
      vm.poolAccountPlansShow = false;
      vm.employeeShow = false;
      vm.employeesWithPendingFeesShow = false;
      vm.employeesAndCreditRechargeShow = false;
      vm.employeePaymentReportShow = false;
      vm.employeeSpreadSheetShow= false;
      vm.plansShow = true;
      vm.poolAccountExtratoShow = false;
    },

    showContracts() {
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = true;
      vm.campaignsShow = false;
      vm.companyShow = false;
      vm.poolAccountProfileShow = false;
      vm.poolAccountCompanyShow = false;
      vm.poolAccountPlansShow = false;
      vm.employeeShow = false;
      vm.employeesWithPendingFeesShow = false;
      vm.employeesAndCreditRechargeShow = false;
      vm.employeePaymentReportShow = false;
      vm.employeeSpreadSheetShow= false;
      vm.plansShow = false;
      vm.poolAccountExtratoShow = false;
    },
    showCampaigns() {
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = false;
      vm.campaignsShow = true;
      vm.companyShow = false;
      vm.poolAccountProfileShow = false;
      vm.poolAccountCompanyShow = false;
      vm.poolAccountPlansShow = false;
      vm.employeeShow = false;
      vm.employeesWithPendingFeesShow = false;
      vm.employeesAndCreditRechargeShow = false;
      vm.employeePaymentReportShow = false;
      vm.employeeSpreadSheetShow= false;
      vm.plansShow = false;
      vm.poolAccountExtratoShow = false;

    },
    showCompany() {
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = false;
      vm.campaignsShow = false;
      vm.companyShow = true;
      vm.poolAccountProfileShow = false;
      vm.poolAccountCompanyShow = false;
      vm.poolAccountPlansShow = false;
      vm.employeeShow = false;
      vm.employeesWithPendingFeesShow = false;
      vm.employeesAndCreditRechargeShow = false;
      vm.employeePaymentReportShow = false;
      vm.employeeSpreadSheetShow= false;
      vm.plansShow = false;
      vm.poolAccountExtratoShow = false;
    },
    showPoolAccountProfile() {
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = false;
      vm.campaignsShow = false;
      vm.companyShow = false;
      vm.poolAccountProfileShow = true;
      vm.poolAccountCompanyShow = false;
      vm.poolAccountPlansShow = false;
      vm.employeeShow = false;
      vm.employeesWithPendingFeesShow = false;
      vm.employeesAndCreditRechargeShow = false;
      vm.employeePaymentReportShow = false;
      vm.employeeSpreadSheetShow= false;
      vm.plansShow = false;
      vm.poolAccountExtratoShow = false;
    },
    showPoolAccountCompany() {
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = false;
      vm.campaignsShow = false;
      vm.companyShow = false;
      vm.poolAccountProfileShow = false;
      vm.poolAccountCompanyShow = true;
      vm.poolAccountPlansShow = false;
      vm.employeeShow = false;
      vm.employeesWithPendingFeesShow = false;
      vm.employeesAndCreditRechargeShow = false;
      vm.employeePaymentReportShow = false;
      vm.employeeSpreadSheetShow= false;
      vm.plansShow = false;
      vm.poolAccountExtratoShow = false;
    },
    showPoolAccountPlans() {
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = false;
      vm.campaignsShow = false;
      vm.companyShow = false;
      vm.poolAccountProfileShow = false;
      vm.poolAccountCompanyShow = false;
      vm.poolAccountPlansShow = true;
      vm.employeeShow = false;
      vm.employeesWithPendingFeesShow = false;
      vm.employeesAndCreditRechargeShow = false;
      vm.employeePaymentReportShow = false;
      vm.employeeSpreadSheetShow= false;
      vm.plansShow = false;
      vm.poolAccountExtratoShow = false;
    },
    showPoolAccountExtrato() {
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = false;
      vm.campaignsShow = false;
      vm.companyShow = false;
      vm.poolAccountExtratoShow = true;
      vm.poolAccountCompanyShow = false;
      vm.poolAccountPlansShow = false;
      vm.employeeShow = false;
      vm.employeesWithPendingFeesShow = false;
      vm.employeesAndCreditRechargeShow = false;
      vm.employeePaymentReportShow = false;
      vm.employeeSpreadSheetShow= false;
      vm.plansShow = false;
    },
    showEmployee(){
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = false;
      vm.campaignsShow = false;
      vm.companyShow = false;
      vm.poolAccountProfileShow = false;
      vm.poolAccountCompanyShow = false;
      vm.poolAccountPlansShow = false;
      vm.employeeShow = true;
      vm.employeesWithPendingFeesShow = false;
      vm.employeesAndCreditRechargeShow = false;
      vm.employeePaymentReportShow = false;
      vm.employeeSpreadSheetShow= false;
      vm.plansShow = false;
      vm.poolAccountExtratoShow = false;
    },
    showEmployeeSpreadSheet(){
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = false;
      vm.campaignsShow = false;
      vm.companyShow = false;
      vm.poolAccountProfileShow = false;
      vm.poolAccountCompanyShow = false;
      vm.poolAccountPlansShow = false;
      vm.employeeShow = false;
      vm.employeesWithPendingFeesShow = false;
      vm.employeesAndCreditRechargeShow = false;
      vm.employeePaymentReportShow = false;
      vm.employeeSpreadSheetShow= true;
      vm.plansShow = false;
      vm.poolAccountExtratoShow = false;

    },
    showEmployeesWithPendingFees(){
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = false;
      vm.campaignsShow = false;
      vm.companyShow = false;
      vm.poolAccountProfileShow = false;
      vm.poolAccountCompanyShow = false;
      vm.poolAccountPlansShow = false;
      vm.employeeShow = false;
      vm.employeesWithPendingFeesShow = true;
      vm.employeesAndCreditRechargeShow = false;
      vm.employeePaymentReportShow = false;
      vm.employeeSpreadSheetShow= false;
      vm.plansShow = false;
      vm.poolAccountExtratoShow = false;
    },
    showEmployeesAndCreditRecharge(){
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = false;
      vm.campaignsShow = false;
      vm.companyShow = false;
      vm.poolAccountProfileShow = false;
      vm.poolAccountCompanyShow = false;
      vm.poolAccountPlansShow = false;
      vm.employeeShow = false;
      vm.employeesWithPendingFeesShow = false;
      vm.employeesAndCreditRechargeShow = true;
      vm.employeePaymentReportShow = false;
      vm.employeeSpreadSheetShow= false;
      vm.plansShow = false;
      vm.poolAccountExtratoShow = false;
    },
    showEmployeePaymentReport(){
      const vm = this;
      vm.dashboardCompanyShow = false;
      vm.contractsShow = false;
      vm.campaignsShow = false;
      vm.companyShow = false;
      vm.poolAccountProfileShow = false;
      vm.poolAccountCompanyShow = false;
      vm.poolAccountPlansShow = false;
      vm.employeeShow = false;
      vm.employeesWithPendingFeesShow = false;
      vm.employeesAndCreditRechargeShow = false;
      vm.employeePaymentReportShow = true;
      vm.employeeSpreadSheetShow= false;
      vm.plansShow = false;
      vm.poolAccountExtratoShow = false;
    },

    getCompany() {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );

      vm.axios
        .put(
          vm.$store.state.filooServer +
            "admin/companies/" +
            vm.$route.params.id +
            "/getAssume"
        )
        .then(function(response) {
          vm.authenticateAsAdmin(response.data.token);
        });
    },
    authenticateAsAdmin(token) {
      const vm = this;
      vm.axios
        .put(vm.$store.state.filooServer + "company/assume/" + token)
        .then(function(response) {
          vm.$session.set("bearer", response.headers.authorization);
        });
    },
    goBackListCompanies(){
      const vm = this;
      vm.$session.set("bearer", vm.bearerDefault);
      vm.$session.start();
      vm.$router.push('/registered-companies');
    }
  }
};
</script>
<style lang="scss" src="./ManageCompany.scss">
</style>
